import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=4e9480a1&lang=pug&"
import script from "./Suppliers.vue?vue&type=script&lang=ts&"
export * from "./Suppliers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports